export const res = {
  loginOtherUser: {
    is: 'Skrá inn annan notanda',
    en: 'Log another user in',
    pl: 'Wpisz nowego użytkownika',
  } as const,
};
